import React from "react";
import Carousel from "../Components/LandingPageComponents/Carousel";
import AboutUs from "../Components/LandingPageComponents/AboutUs";
import Services from "../Components/LandingPageComponents/Services";
import Testimonials from "../Components/LandingPageComponents/Testimonials";
import ContactUs from "../Components/LandingPageComponents/ContactUs";
import Headline from "../Components/LandingPageComponents/Headline";
import Card1 from "../Components/LandingPageComponents/Card1";
import Packages from "../Components/LandingPageComponents/Packages";
import Testimonials2 from "../Components/LandingPageComponents/Testimonials2";
import DemoCallCard from "../Components/LandingPageComponents/DemoCallCard";
import Card2 from "../Components/LandingPageComponents/Card2";
import AuditCallCard from "../Components/LandingPageComponents/AuditCallCard";
import CompanyTrustUs from "../Components/LandingPageComponents/CompanyTrustUs";
import Card3 from "../Components/LandingPageComponents/Card3";
import VideoCard1 from "../Components/LandingPageComponents/VideoCard1";
import Testimonials3 from "../Components/LandingPageComponents/Testimonials3";

const LandingPage = () => {
  return (
    <div className=" pt-[70px] text-[#3B2E22] bg-[#dbc3ab] md:bg-[#f7dbb6] ">
      {/* <div className="fixed -top-[70px] left-0 h-screen w-screen flex justify-center items-center ">
        <img src="banner.png" className="h-full w-full object-contain" />
      </div> */}

      <div className="z-[10] bg-[#dbc3ab] md:bg-[#f7dbb6] backdrop-blur-md">
        {/* <Carousel /> */}
        <Headline />
        <AboutUs />
        <Testimonials3 />
        <Card3 />
        <VideoCard1 />
        <Card1 />

        <Packages />
        <Card3 />

        {/* <CompanyTrustUs /> */}
        <Testimonials2 />
        <DemoCallCard />
        <Card2 />
        <AuditCallCard />
        <Services />
        <div className="pb-10">
          <Card3 />
        </div>

        {/* <Testimonials />
      <ContactUs /> */}
      </div>
    </div>
  );
};

export default LandingPage;
